import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8806d2c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leave-melati" }
const _hoisted_2 = { class: "background-circle" }
const _hoisted_3 = {
  ref: "circle",
  class: "circle"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Deel ook jouw gedachten en plaats een melati bij het monument", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, null, 512)
    ]),
    _hoisted_4,
    _createVNode(_component_router_link, {
      to: "/melati/new",
      class: "outline-btn melati-btn"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Icon, { name: "melati" }),
        _createTextVNode(" Plaats je melati ")
      ]),
      _: 1
    })
  ]))
}